const filter = require('lodash/filter')
const forEach = require('lodash/forEach')

module.exports = ['$rootScope', '$q', 'Promise', 'User', '$utils', '$translate', 'IndexedDB', 'MailFolderType',
  function ($rootScope, $q, Promise, User, $utils, $translate, IndexedDB, MailFolderType) {
    let allFolders = [] // getAllFolders 返回的结果
    let allFoldersId = [] // 所有文件夹id（包括自定义文件夹）
    let unReadFolderIds = [] // 未读邮件文件夹id范围
    let flaggedFolderIds = [] // 标记邮件文件夹id范围
    let deferHandleFolderIds = [] // 待办邮件文件夹id范围

    // 需要从服务器获取的数据
    function getCacheFolderData(name) {
      const data = {
        allFolders,
        allFoldersId,
        unReadFolderIds,
        flaggedFolderIds,
        deferHandleFolderIds
      }
      return name ? data[name] : data
    }

    /**
       * 获取指定文件夹的统计信息
       * @param fid 文件夹的id
       * @returns 返回该文件夹的统计信息
       */
    function getFolderStatsInfo(fid, mboxAccount) {
      if (!fid) return $q.reject()

      // 获取实体文件夹的统计信息
      const getRealFolderStats = function(fid, mboxAccount) {
        const deferred = $q.defer()
        let params = {
          ids: fid,
          message: true
        }
        const mboxa = mboxAccount === '' ? '' : (mboxAccount || User.getSelectedAccountSymbol())
        if (mboxa) params = { ...params, mboxa }
        Promise.wmCall('mbox:getFolderStats', params).then(function (data) {
          if (data.code !== 'S_OK') return deferred.reject([])

          deferred.resolve(data['var'][fid])
        }, function () {
          deferred.reject([])
        })
        return deferred.promise
      }

      // 获取虚拟文件夹的统计信息
      const getVirtualFolderStats = function(fid, mboxAccount) {
        const deferred = $q.defer()
        let params = null
        switch (fid) {
          case -1: // 重要邮件
            params = {
              fids: [],
              returnTotal: true,
              mode: 'count',
              skipLockedFolders: true,
              filterFlags: { read: false, vip: true },
              limit: 0
            }
            break
          case -2: // 未读邮件（依赖unReadFolderIds预先初始化）
            params = {
              fids: getCacheFolderData('unReadFolderIds'),
              skipLockedFolders: true,
              returnTotal: true,
              filterFlags: { read: false },
              mode: 'count',
              limit: 0
            }
            break
          case -3: // 已标记邮件
            params = {
              fids: getCacheFolderData('flaggedFolderIds'),
              returnTotal: true,
              skipLockedFolders: true,
              mode: 'count',
              filterFlags: { read: false, flagged: true },
              limit: 0
            }
            break
          case -5: // 待办邮件
            params = {
              fids: getCacheFolderData('deferHandleFolderIds'),
              skipLockedFolders: true,
              returnTotal: true,
              mode: 'count',
              filterFlags: { read: false, deferHandle: true },
              limit: 0
            }
            break
          default:
            break
        }
        const mboxa = mboxAccount === '' ? '' : (mboxAccount || User.getSelectedAccountSymbol())
        if (mboxa) params = { ...params, mboxa }

        // 列举邮件
        Promise.wmCall('mbox:listMessages', params).then(function (data) {
          if (data.code !== 'S_OK') return deferred.reject({})

          deferred.resolve({ unreadMessageCount: data.total })
        }, function () {
          deferred.reject({})
        })
        return deferred.promise
      }

      return fid >= 0 ? getRealFolderStats(fid, mboxAccount) : getVirtualFolderStats(fid, mboxAccount)
    }

    /**
       * 获取所有实体文件夹
       * @returns 返回所有实体文件夹的对象列表
       * @description 缓存调用成功数据，以便接口调用失败的话使用本地缓存的文件夹列表
       */
    function getAllFolders(mboxAccount) {
      let params = {stats: true}
      const mboxa = mboxAccount === '' ? '' : (mboxAccount || User.getSelectedAccountSymbol())
      if (mboxa) params = { ...params, mboxa }

      const errorHandler = function(err) {
        if ($rootScope.settings.enableMailCache && IndexedDB.isReady()) {
          return IndexedDB.getItem('mail_folder_cache').then(cache => cache || [])
        } else {
          return $q.reject(err)
        }
      }

      const getAllFoldersId = function(item, arr = []) {
        arr.push(item.id)
        item.children = item.children || []
        forEach(item.children, child => {
          getAllFoldersId(child, arr)
        })
        return arr
      }

      return Promise.wmCall('mbox:getAllFolders', params).then(function (data) {
        if (data.code !== 'S_OK') return errorHandler(data)

        if ($rootScope.settings.enableMailCache && IndexedDB.isReady()) {
          IndexedDB.setItem('mail_folder_cache', data.var)
        }
        /** 判断第三方网盘是否开启
           * logined 已经登录才会调用此接口
           * xnfSwitch 存在则无需重复调用接口
          */
        const user = User.getCurrentUser()
        if (!user.config.hasOwnProperty('xnfSwitch')) {
          User.getXnfConfig().then(res => { user.config.xnfSwitch = res })
        }
        allFolders = data.var || []
        allFoldersId = getAllFoldersId({id: 0, children: allFolders}, []).slice(1)
        const excludeUnReadFolderIds = [MailFolderType.TRASH, MailFolderType.SPAM, MailFolderType.VIRUS] // 需要排除的未读邮件id
        unReadFolderIds = filter(allFoldersId, id => !~excludeUnReadFolderIds.indexOf(id))
        deferHandleFolderIds = flaggedFolderIds = filter(allFoldersId, id => id !== MailFolderType.TRASH)
        return allFolders
      }, errorHandler)
    }

    return {
      getCacheFolderData: getCacheFolderData,
      getFolderStatsInfo: getFolderStatsInfo,
      getAllFolders: getAllFolders,
    }
  }]



// WEBPACK FOOTER //
// ./src/js/services/globalFolderService.js